import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import styled from 'styled-components';
import { useSelector } from 'react-redux';
import {
  getRouteName,
  NOT_ALLOWED_BACK_ROUTES,
  ROUTES_MAP,
} from 'app/shared/utils/routes';
import {
  U21Button,
  U21Spacer,
  U21Typography,
} from 'app/shared/u21-ui/components';
import {
  getObjectTypeLabel,
  OBJECT_TYPE_TO_ROUTE,
} from 'app/shared/utils/externalIdError';
import { selectRoutingHistory } from 'app/modules/navigator/selectors';

export const ExternalIdDetected = () => {
  const { search } = useLocation();
  const params = new URLSearchParams(search);
  const hashId = params.get('hash_id') ?? undefined;
  const objectType = params.get('type') ?? undefined;
  const existsInOpenSearch = params.get('exists') === 'true';
  const routingHistory = useSelector(selectRoutingHistory);

  const objectTypeLabel = getObjectTypeLabel(objectType);
  const hashIdRoute =
    hashId && objectType
      ? OBJECT_TYPE_TO_ROUTE[objectType]?.(hashId)
      : undefined;

  const route = useMemo(() => {
    const validRoute = {
      path: '',
      name: '',
    };

    for (const i of routingHistory) {
      const routeName = getRouteName(i.route);
      if (!NOT_ALLOWED_BACK_ROUTES[i.route] && routeName) {
        validRoute.path = i.route;
        validRoute.name = routeName;
        break;
      }
    }

    return validRoute;
  }, [routingHistory]);

  return (
    <StyledContainer>
      <Header>
        <U21Typography variant="h1">404</U21Typography>
        <U21Typography variant="h4">Outdated format</U21Typography>
      </Header>
      {existsInOpenSearch ? (
        <U21Typography variant="body1">
          This {objectTypeLabel} was looked up using an outdated format.
          {hashIdRoute && (
            <>
              {' '}
              <U21Button color="primary" to={hashIdRoute} variant="text">
                Click here for the correct link.
              </U21Button>
            </>
          )}
        </U21Typography>
      ) : (
        <U21Typography variant="body1">
          This {objectTypeLabel} was looked up using an outdated format. We
          could not find a corresponding page to redirect you to.
        </U21Typography>
      )}
      {route.path ? (
        <U21Button color="primary" to={route.path} variant="text">
          Go back to {route.name}
        </U21Button>
      ) : (
        <U21Button color="primary" to={ROUTES_MAP.home.path} variant="text">
          Take me home
        </U21Button>
      )}
    </StyledContainer>
  );
};

const StyledContainer = styled(U21Spacer)`
  align-items: center;
  margin-top: ${({ theme }) => theme.spacing(12)};
`;

const Header = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;
